import {
    Copy,
    Edit2,
    Eye,
    Heart,
    More,
    Share,
    Trash,
} from "iconsax-react";
import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { CONTENT_STATUS } from "./constants";
import { formatCount, statusKey, targetLabel, thumbnailUrlFor, typeKey } from "./helpers";
import MediaPreview from "./MediaPreview";

export default function ContentCard({
    content,
    locale,
    onEdit,
    onShare,
    onDuplicate,
    onDelete,
    onSubmit,
}) {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuId = useId();
    const status = statusKey(content.status);
    const type = typeKey(content.content_type);
    const thumb = thumbnailUrlFor(content);

    return (
        <article className="studio-card">
            <div className="studio-card-cover">
                {thumb ? (
                    <img src={thumb} alt="" />
                ) : (
                    <MediaPreview content={content} />
                )}
                <span className={`studio-type-chip studio-type-${type}`}>
                    {t(`contentStudio.type.${type}`)}
                </span>
                <span className={`studio-status studio-status-${status}`}>
                    {t(`contentStudio.status.${status}`)}
                </span>
            </div>
            <div className="studio-card-body">
                <h3>{content.name}</h3>
                <p>{content.description || t("contentStudio.noDescription")}</p>
                <div className="studio-card-meta">
                    <span>{targetLabel(content, t)}</span>
                    <span>
                        <Eye size={14} aria-hidden="true" />
                        {formatCount(content.views_count, locale)}
                    </span>
                    <span>
                        <Share size={14} aria-hidden="true" />
                        {formatCount(content.shares_count, locale)}
                    </span>
                    <span>
                        <Heart size={14} aria-hidden="true" />
                        {formatCount(content.likes_count, locale)}
                    </span>
                </div>
                {content.status === CONTENT_STATUS.REJECTED && content.review_note ? (
                    <p className="studio-card-note" role="status">
                        {content.review_note}
                    </p>
                ) : null}
            </div>
            <div className="studio-card-actions">
                <button type="button" onClick={() => onEdit(content)}>
                    <Edit2 size={16} aria-hidden="true" />
                    {t("contentStudio.edit")}
                </button>
                {content.status === CONTENT_STATUS.CONFIRMED ? (
                    <button type="button" onClick={() => onShare(content)}>
                        <Share size={16} aria-hidden="true" />
                        {t("contentStudio.share")}
                    </button>
                ) : null}
                {content.status === CONTENT_STATUS.DRAFT ||
                content.status === CONTENT_STATUS.REJECTED ? (
                    <button type="button" onClick={() => onSubmit(content)}>
                        {t("contentStudio.submit")}
                    </button>
                ) : null}
                <div className="studio-card-more">
                    <button
                        type="button"
                        aria-haspopup="menu"
                        aria-expanded={menuOpen}
                        aria-controls={menuId}
                        aria-label={t("contentStudio.more")}
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        <More size={18} aria-hidden="true" />
                    </button>
                    {menuOpen ? (
                        <div id={menuId} role="menu" className="studio-menu">
                            <button
                                type="button"
                                role="menuitem"
                                onClick={() => {
                                    setMenuOpen(false);
                                    onDuplicate(content);
                                }}
                            >
                                <Copy size={16} aria-hidden="true" />
                                {t("contentStudio.duplicate")}
                            </button>
                            <button
                                type="button"
                                role="menuitem"
                                className="danger"
                                onClick={() => {
                                    setMenuOpen(false);
                                    onDelete(content);
                                }}
                            >
                                <Trash size={16} aria-hidden="true" />
                                {t("contentStudio.delete")}
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        </article>
    );
}
